import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.f4{gap:0.38rem;}.ssr-plugin'
import type { FieldPath, FieldValues } from 'react-hook-form'
import { Toggle, type ToggleOption } from '../../toggle/Toggle'
import { FormField } from '../FormField'
import { styled } from 'inlines'
import { Text } from '../../typography/Text'

export type ToggleFieldProps<
  T extends FieldValues = FieldValues,
  V extends string | boolean = string,
> = {
  name: FieldPath<T>
  options: ToggleOption<V>[]
  label?: string
}

export const ToggleField = <
  T extends FieldValues = FieldValues,
  V extends string | boolean = string,
>({
  name,
  label,
  options,
}: ToggleFieldProps<T, V>) => {
  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, errorMessage }) => (
        <div className="a b f4"
        >
          {label && (
            <Text.Medium style={{ color: 'var(--palette-blue-500)' }}>
              {label}
            </Text.Medium>
          )}
          <Toggle<V>
            options={options}
            selectedOption={(value as V) ?? options[0]?.value}
            setSelectedOption={onChange}
            style={{ alignSelf: 'stretch' }}
          />
          {errorMessage && <Text.FormError>{errorMessage}</Text.FormError>}
        </div>
      )}
    />
  )
}
